import { getOidcSessionKey } from '../config/oidcConfig';
import { bannerService } from '../error/BannerService';
import type { HttpProblem } from './generated/client';
import type { CreateClientConfig } from './generated/client/client';
import { client } from './generated/client/client.gen';

export function getHost() {
    const urlString = import.meta.url;
    if (!urlString || !isAbsoluteUrl(urlString)) return '';

    return new URL(urlString).origin;
}

function isAbsoluteUrl(urlString: string) {
    return urlString.indexOf('http://') === 0 || urlString.indexOf('https://') === 0;
}

export const createClientConfig: CreateClientConfig = (config) => ({
    ...config,
    baseURL: getHost(),
    throwOnError: true,
});

export function setupInterceptors(): void {
    client.instance.interceptors.request.use(async (config) => {
        // IE bugfix for caching ajax GET requests
        // see https://stackoverflow.com/questions/45912500/reactjs-ie11-not-making-new-http-request-using-cached-data
        // see https://thisinterestsme.com/ajax-request-internet-explorer-cache/
        config.headers['Cache-Control'] = 'no-cache';
        config.headers['Pragma'] = 'no-cache';
        config.headers['language'] = 'en';

        const oidcSessionKey = await getOidcSessionKey();
        const storedUser = JSON.parse(localStorage.getItem(oidcSessionKey) ?? '');
        if (storedUser) {
            config.headers['Authorization'] = `Bearer ${storedUser.access_token}`;
        }

        return config;
    });

    client.instance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const resp = error?.response;
            if (!resp) return Promise.reject(error);

            const contentType = resp.headers?.['content-type']?.toLowerCase() ?? '';

            if (resp.data instanceof ArrayBuffer && contentType.includes('application/problem+json')) {
                try {
                    const text = new TextDecoder('utf-8').decode(new Uint8Array(resp.data));
                    const json = JSON.parse(text);
                    bannerService.show(json as HttpProblem);
                } catch (e) {
                    console.error('Failed to parse ArrayBuffer JSON:', e);
                }
            } else if (contentType.includes('application/problem+json') && typeof resp.data === 'object') {
                bannerService.show(resp.data as HttpProblem);
            }

            return Promise.reject(error);
        },
    );
}
